import { getLoyaltyProgram } from "../../../../app/api/getLoyaltyProgram";
import { BaseAction } from "../../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../../Orchestrator/Recoils/Events/Recoil";
import { ILoyaltyProgramActionParams } from "../../../../Orchestrator/Types/Interface/ActionParams/LoyaltyProgramActionParams";
import { ILoyaltyProgramResponse } from "../../../../Orchestrator/Types/Interface/ILoyaltyProgram";

export class LoyaltyProgramAction extends BaseAction<
  ILoyaltyProgramResponse | null,
  ILoyaltyProgramActionParams
> {
  override async run(): Promise<ILoyaltyProgramResponse | null> {
    const { userId } = this.params!;
    let loyaltyProgramData: ILoyaltyProgramResponse | null = null;
    try {
      const response: any = await getLoyaltyProgram(userId);
      if (response.status === "ok" && response.answer) {
        loyaltyProgramData = response.answer as ILoyaltyProgramResponse;
        updateRecoilState("loyaltyProgramDataAtom", loyaltyProgramData);
      }
    } catch (error) {
      console.error("Error during fetching enrollment:", error);
    } finally {
      return loyaltyProgramData;
    }
  }
}
export const getLoyaltyProgramAction = new LoyaltyProgramAction();
